import _merge from 'lodash/merge';

import axios from 'axios';
import user from './../extra/user';

/**
 * @param {string} endpoint - API endpoint
 * @param {import('axios').AxiosRequestConfig & {
 *  isPublic: boolean,
 * }} options - Request options
 */
export default function get(endpoint = '', { isPublic, ...config } = {}) {
  if (!endpoint) {
    throw new Error('API Endpoint was not provided');
  }

  const token = user.getToken();

  const axiosConfig = _merge(
    { headers: isPublic ? {} : { Authorization: `Token ${token}` } },
    config,
  );

  return axios.get(endpoint, axiosConfig);
}
